<template>
  <div class="chatCommunityPage">
    <div class="qrcodeBox">
      <img :src="qrcode" />
    </div>
    <Loading ref="load"/>
  </div>
</template>

<script>
import { reqCourseDetail } from '@/api/courseDetail';
import Loading from '@/components/loading/loading.vue';
export default {
  name: 'chatCommunityPage',
  data() {
    return {
      productId: this.$route.query.productId,
      skuId: this.$route.query.skuId,
      qrcode: '',
    };
  },
  components: {
    Loading,
  },
  methods: {
    async courseDetail() {
      this.$refs.load.show = true;
      const { data } = await reqCourseDetail(this.productId);
      this.$refs.load.show = false;
      const productSkuInfo = data?.productSkuRespVOList?.find(item=> item?.productSkuId === Number(this.skuId))
      this.qrcode = productSkuInfo?.productCommunityRespVO?.qrcode;
    },
  },
  mounted() {
    this.courseDetail()
  },
};
</script>

<style lang="scss" scoped>
.chatCommunityPage{
  width: 100%;
  background-size: 100%;
  min-height: 100vh;
  background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/pullNew/qrcodeBg.png') no-repeat,
  linear-gradient(to bottom, #c0f4fe, #5ebbfe);
  background-size: 100%;
  position: relative;
}
.qrcodeBox{
  width: 100%;
  position: absolute;
  left: 0;
  top: 499px;
  text-align: center;
  img{
    width: 390px;
    height: 390px;
    display: block;
    margin: auto;
  }
}
</style>
